<template>
	<div class="animation_content">
		<div class="snowDown" v-if="id == 1">
			<img src="/static/images/a1.jpg" class="loadding" v-if="amountValue > 0 && amountValue <= 3999" />
			<img src="/static/images/a2.jpg" class="loadding" v-if="amountValue > 4000 && amountValue <= 7999" />
			<img src="/static/images/a3.jpg" class="loadding" v-if="amountValue > 8000 && amountValue <= 15999" />
			<img src="/static/images/a4.jpg" class="loadding" v-if="amountValue > 16000 && amountValue <= 25999" />
			<img src="/static/images/a5.jpg" class="loadding" v-if="amountValue > 26000 && amountValue <= 40078" />
		</div>
		<div class="snowDown" v-if="id == 2">
			<img src="/static/images/a1.jpg" class="loadding" v-if="amountValue > 0 && amountValue <= 10000" />
			<img src="/static/images/a2.jpg" class="loadding" v-if="amountValue > 10001 && amountValue <= 20000" />
			<img src="/static/images/a3.jpg" class="loadding" v-if="amountValue > 20001 && amountValue <= 40000" />
			<img src="/static/images/a4.jpg" class="loadding" v-if="amountValue > 40001 && amountValue <= 65999" />
			<img src="/static/images/a5.jpg" class="loadding" v-if="amountValue > 66000 && amountValue <= 85816" />
		</div>
		<div class="snowDown" v-if="id == 3">
			<img src="/static/images/a1.jpg" class="loadding" v-if="amountValue > 0 && amountValue <= 9999" />
			<img src="/static/images/a2.jpg" class="loadding" v-if="amountValue > 10000 && amountValue <= 19999" />
			<img src="/static/images/a3.jpg" class="loadding" v-if="amountValue > 20000 && amountValue <= 49999" />
			<img src="/static/images/a4.jpg" class="loadding" v-if="amountValue > 50000 && amountValue <= 79999" />
			<img src="/static/images/a5.jpg" class="loadding" v-if="amountValue > 80000 && amountValue <= 101700" />
		</div>
		<div class="snowDown" v-if="id == 4">
			<img src="/static/images/a1.jpg" class="loadding" v-if="amountValue > 0 && amountValue <= 8888" />
			<img src="/static/images/a2.jpg" class="loadding" v-if="amountValue > 8889 && amountValue <= 43888" />
			<img src="/static/images/a3.jpg" class="loadding" v-if="amountValue > 43888 && amountValue <= 88888" />
			<img src="/static/images/a4.jpg" class="loadding" v-if="amountValue > 88889 && amountValue <= 128888" />
			<img src="/static/images/a5.jpg" class="loadding" v-if="amountValue > 128889 && amountValue <= 307216" />
		</div>
		<div class="loadding"><img src="/static/images/loadding.png" /></div>
	</div>
</template>

<script>
export default {
	name: 'home',
	components: {},
	data: function () {
		return {
			id: this.$route.query.id,
			username: this.$route.query.username,
			amountValue: this.$route.query.amountValue
		};
	},
	mounted() {
		var _this = this;
		let msgData = {
			id: this.id,
			username: this.username,
			amountValue: this.amountValue
		};
		localStorage.setItem('msgData', JSON.stringify(msgData));
		console.log(this.id);
		console.log(this.username);
		console.log(this.amountValue);
		setTimeout(function () {
			alert(111);
			// _this.$router.push({path:'/result?id='+this.id+'&username='+this.username+'&amountValue='+this.amountValue});
			_this.$router.push({ path: '/result' });
			// this.$router.push({path:'/animation'});
		}, 3000);
	},
	methods: {}
};

// 百度统计代码
var _hmt = _hmt || [];
(function () {
	var hm = document.createElement('script');
	hm.src = 'https://hm.baidu.com/hm.js?ad99db41be5b87499521b6c4980a6ec2';
	var s = document.getElementsByTagName('script')[0];
	s.parentNode.insertBefore(hm, s);
})();
</script>

<style lang="scss" scoped>
@function px2rem($px) {
	@return $px / 75;
}
.snowDown {
	animation: snowDown 5s linear infinite normal;
	-webkit-animation: snowDown 5s linear infinite normal;
	position: relative;
}
@keyframes snowDown {
	from {
		opacity: 1;
		top: 0;
	}
	to {
		opacity: 0;
		top: 80em;
	}
}

.loadding {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	-moz-animation-duration: 1s;
	-moz-animation-delay: 0.2s;
	-moz-animation-timing-function: ease;
	-moz-animation-fill-mode: both;
	-ms-animation-duration: 1s;
	-ms-animation-delay: 0.2s;
	-ms-animation-timing-function: ease;
	-ms-animation-fill-mode: both;
	animation-duration: 1s;
	animation-delay: 0.2s;
	animation-timing-function: ease;
	animation-fill-mode: both;
}
</style>



// WEBPACK FOOTER //
// src/pages/game/animation.vue